// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

import type { ViewDoc } from "../kontrakt";

export interface PolaSterownikNow {
  t_condenser: number | null;
  t_water: number | null;
  t_shelf10: number | null;
  t_buffer: number | null;
  t_tank: number | null;
  t_jacket: number | "LOW" | null;
  t_day: number | null;
  polm: boolean | null;
  process_s: number | null;
  olm_s: number | null;
  warmup_s: number | null;
  phase_s: number | null;
  dumps_done: number | null;
  dumps_planned: number | null;
  buffer_unstable: boolean | null;
  ble_pairing: boolean | null;
  rssi: number | null;
  power_l1_kw: number | null;
  power_l2_kw: number | null;
  power_l3_kw: number | null;
  volt_l1: number | null;
  volt_l2: number | null;
  volt_l3: number | null;
  pump_dispensed_ml: number | null;
  pump_flow: number | null;
  pump_total_l: number | null;
  pump_wear: number | null;
  pump_calib: boolean | null;
  pump_calib_missing: boolean | null;
  pump_link: boolean | null;
  pump_ver: string | null;
  meter_link: boolean | null;
  meter_ver: string | null;
  tank_done: number | null;
  tank_full: boolean | null;
  tank_eta_min: number | null;
}

export interface NastawySterownikNow {
  ileZrzutow: number | null;
  czasLM: number | null;
  mocRobocza: number | null;
  G1: number | null;
  G2: number | null;
  G3: number | null;
  minimalnyOLM: number | null;
  maxOLM: number | null;
  czyszczenieUFO: boolean | null;
  abratek: boolean | null;
  stabilizator: boolean | null;
  TZMR: number | null;
  mocNomL1: number | null;
  mocNomL2: number | null;
  mocNomL3: number | null;
  rotoOLM: boolean | null;
  NTC: boolean | null;
  maleZrzuty: boolean | null;
  pracaBuforem: boolean | null;
  czasPlukania: number | null;
  proces: 1 | 2 | 3 | null;
  zacier: boolean | null;
  tempZacierania: number | null;
  ustawTempDnia: number | null;
  tempH2oStop: number | null;
  tempUFOstop: number | null;
  korUFO: number | null;
  kor10p: number | null;
  korBufor: number | null;
  korZbiornik: number | null;
  ktzjb: number | null;
  ktbc: number | null;
  stopTime: number | null;
  ktzbb: number | null;
  ktbt: number | null;
  deltaTempDnia: number | null;
  histTempDnia: number | null;
  stab1czas: number | null;
  stab3czas: number | null;
  stab2czas: number | null;
  deltaBufor: number | null;
  DlugieChlodzenie: boolean | null;
  G2rob: boolean | null;
  G3rob: boolean | null;
  EZolm: number | null;
  EZlm: number | null;
  EZh2o: number | null;
  light: boolean | null;
  mixer: boolean | null;
  trybAuto: boolean | null;
  praca: boolean | null;
  pumpTank: number | null;
  pumpMaxFlow: number | null;
}

/** Stan procesu w widoku (`state`) - etykiety z opisu procesu linii. */
export type StanSterownikNow = "BLAD_POMIARU" | "BRAK_CZUJNIKOW" | "BRAK_LICZNIKA" | "BRAK_POMPY" | "BUFOR_NIESTABILNY" | "GRZALKA_L1" | "GRZALKA_L2" | "GRZALKA_L3" | "GRZALKI_WSZYSTKIE" | "KONIEC" | "NACZYNIE_PELNE" | "ODBIOR_OLM" | "ODBIOR_PRZEDGONU_LM" | "PLUKANIE_OLM" | "ROZGRZEWANIE" | "SKOK_10P_STABILIZUJE" | "STABILIZACJA" | "STABILIZACJA_KONCOWA" | "STOP" | "STOP_AWARIA" | "STOP_KOMUNIKACJA" | "STOP_PRZEGRZANIE" | "SUCHA_KOLUMNA" | "ZANIK_FAZY_L1" | "ZANIK_FAZY_L2" | "ZANIK_FAZY_L3" | "ZANIK_NAPIECIA";

export interface WidokSterownikNow extends Omit<ViewDoc, "fields" | "settings" | "no_sensor" | "state"> {
  type: "sterownik-now";
  state?: StanSterownikNow;
  fields: PolaSterownikNow;
  settings?: NastawySterownikNow;
  no_sensor?: Array<keyof PolaSterownikNow>;
}

export const KOMENDY_STEROWNIKNOW = {
  "nastawy": {
    "DlugieChlodzenie": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "EZh2o": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "EZlm": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie",
      "blokada": [
        "EZolm"
      ]
    },
    "EZolm": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie",
      "blokada": [
        "EZlm"
      ]
    },
    "G1": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "G2": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "G2rob": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "G3": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "G3rob": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "NTC": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "TZMR": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 9000,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "abratek": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "czasLM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 600,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "czasPlukania": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 3600,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "czyszczenieUFO": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "deltaBufor": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 50,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "deltaTempDnia": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 20,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "histTempDnia": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 20,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ileZrzutow": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "kor10p": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "korBufor": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "korUFO": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "korZbiornik": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ktbc": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ktbt": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ktzbb": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ktzjb": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "light": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "maleZrzuty": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "maxOLM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "minimalnyOLM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "mixer": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "mocNomL1": {
      "rodzaj": "liczba",
      "min": 500,
      "max": 4000,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "mocNomL2": {
      "rodzaj": "liczba",
      "min": 500,
      "max": 4000,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "mocNomL3": {
      "rodzaj": "liczba",
      "min": 500,
      "max": 4000,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "mocRobocza": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "praca": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "pracaBuforem": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "proces": {
      "rodzaj": "lista",
      "wartosci": [
        1,
        2,
        3
      ],
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "pumpMaxFlow": {
      "rodzaj": "liczba",
      "min": 10,
      "max": 50,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "pumpTank": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 1000,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "rotoOLM": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "stab1czas": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 7200,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "stab2czas": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 7200,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "stab3czas": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 7200,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "stabilizator": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "stopTime": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 3600,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tempH2oStop": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tempUFOstop": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tempZacierania": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "trybAuto": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "ustawTempDnia": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "zacier": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    }
  },
  "akcje": {
    "blePair": {
      "poziom": "sterowanie"
    },
    "fabryczne": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    },
    "kwhReset": {
      "poziom": "sterowanie"
    },
    "panelPair": {
      "poziom": "sterowanie"
    },
    "pumpCalib": {
      "tresci": [
        "start",
        "200",
        "cancel"
      ],
      "poziom": "sterowanie"
    },
    "pumpReset": {
      "poziom": "sterowanie"
    },
    "pumpTankAck": {
      "poziom": "sterowanie"
    },
    "reset": {
      "poziom": "restart",
      "skutek": "online",
      "czas_s": 180
    },
    "resetWiFi": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    }
  },
  "zestawy": {
    "ustawienia": {
      "pola": [
        "ileZrzutow",
        "czasLM",
        "mocRobocza",
        "minimalnyOLM",
        "maxOLM",
        "abratek",
        "stabilizator",
        "TZMR",
        "mocNomL1",
        "mocNomL2",
        "mocNomL3",
        "rotoOLM",
        "NTC",
        "maleZrzuty",
        "pracaBuforem",
        "czyszczenieUFO",
        "proces",
        "tempZacierania",
        "korUFO",
        "kor10p",
        "korBufor",
        "korZbiornik",
        "ktzjb",
        "ktbc",
        "stopTime",
        "ktzbb",
        "ktbt",
        "deltaTempDnia",
        "histTempDnia",
        "stab1czas",
        "stab3czas",
        "stab2czas",
        "deltaBufor",
        "tempUFOstop",
        "DlugieChlodzenie",
        "G2rob",
        "G3rob"
      ],
      "poziom": "sterowanie"
    }
  },
  "czas_potwierdzenia_s": 10
} as const;

/** Etapy procesu po stanie widoku (`state`), w kolejności firmware; `procesy` pusta = każdy typ procesu. */
export const ETAPY_STEROWNIKNOW = [
  {
    "nazwa": "Rozgrzewanie",
    "stany": [
      "ROZGRZEWANIE"
    ],
    "procesy": []
  },
  {
    "nazwa": "Stabilizacja",
    "stany": [
      "STABILIZACJA"
    ],
    "procesy": [
      1
    ]
  },
  {
    "nazwa": "Przedgon LM",
    "stany": [
      "ODBIOR_PRZEDGONU_LM"
    ],
    "procesy": [
      1
    ]
  },
  {
    "nazwa": "Stab. końcowa",
    "stany": [
      "STABILIZACJA_KONCOWA"
    ],
    "procesy": [
      1,
      2
    ]
  },
  {
    "nazwa": "Płukanie OLM",
    "stany": [
      "PLUKANIE_OLM"
    ],
    "procesy": [
      1,
      2
    ]
  },
  {
    "nazwa": "Odbiór OLM",
    "stany": [
      "ODBIOR_OLM",
      "SKOK_10P_STABILIZUJE"
    ],
    "procesy": [
      1,
      2
    ]
  }
] as const;

/** Kanały wykresu (numer w próbkach i w punkcie na żywo `widok.wykres`) z nazwą domyślną z opisu linii. */
export const KANALY_STEROWNIKNOW = [
  {
    "idx": 0,
    "nazwa": "Skraplacz",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 1,
    "nazwa": "Woda IN",
    "ukryty": false,
    "zimny": true
  },
  {
    "idx": 2,
    "nazwa": "10-ta półka",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 3,
    "nazwa": "Bufor",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 4,
    "nazwa": "Zbiornik",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 5,
    "nazwa": "Płaszcz",
    "ukryty": false,
    "zimny": false
  }
] as const;

/** Progi koloru temperatury (KN-20): poziom = liczba progów ≤ wartości, kolor `--iot-temp-<poziom+1>`. */
export const PROGI_KOLORU_STEROWNIKNOW = [35,70,78,86,93] as const;

/** Nazwy kodów firmware dla człowieka (programy, fazy - Type.Names); kod spoza słownika bez zmian. */
export const NAZWY_STEROWNIKNOW: Readonly<Record<string, string>> = {"BLAD_POMIARU":"Błąd pomiaru","BRAK_CZUJNIKOW":"Brak czujników","BRAK_LICZNIKA":"Brak licznika","BRAK_POMPY":"Brak pompy","BUFOR_NIESTABILNY":"Bufor niestabilny","DESTYLACJA":"Destylacja","GRZALKA_L1":"G1 nie grzeje","GRZALKA_L2":"G2 nie grzeje","GRZALKA_L3":"G3 nie grzeje","GRZALKI_WSZYSTKIE":"Grzałki nie grzeją","KONIEC":"Koniec","NACZYNIE_PELNE":"Naczynie pełne","ODBIOR_OLM":"Odbiór OLM","ODBIOR_PRZEDGONU_LM":"Odbiór przedgonu LM","PLUKANIE_OLM":"Płukanie OLM","ROZGRZEWANIE":"Rozgrzewanie","SKOK_10P_STABILIZUJE":"Skok 10P · stabilizacja","STABILIZACJA":"Stabilizacja","STABILIZACJA_KONCOWA":"Stabilizacja końcowa","STOP":"Stop","STOP_AWARIA":"Stop · awaria","STOP_KOMUNIKACJA":"Stop · komunikacja","STOP_PRZEGRZANIE":"Stop · przegrzanie","SUCHA_KOLUMNA":"Sucha kolumna","ZANIK_FAZY_L1":"Zanik fazy L1","ZANIK_FAZY_L2":"Zanik fazy L2","ZANIK_FAZY_L3":"Zanik fazy L3","ZANIK_NAPIECIA":"Zanik napięcia"};

